module.exports = __webpack_public_path__ + "img/climate_actions_certificate.d8f228c.svg";